angular.module('impactx.list').directive('ixListDateFilter', function(){
    return {
        restrict: 'E',
        scope: {
            field: '=',
            suffix: '@'
        },
        require: '^stTable',
        templateUrl: 'shared/list/templates/listdatefilter.tmpl.html',
        link: function (scope, element, attr, ctrl) {
            scope.field.date.dateValue = null;
            scope.change = function change () {
                if (scope.field.date.dateValue)
                {
                    ctrl.search(scope.field.date.dateValue.getDate() < 10 ?
                        ("0" + scope.field.date.dateValue.getDate()) : scope.field.date.dateValue.getDate(), scope.field.dayField);
                    ctrl.search(scope.field.date.dateValue.getMonth() < 10 ?
                        ("0" + scope.field.date.dateValue.getMonth()) : scope.field.date.dateValue.getMonth(), scope.field.monthField);
                    ctrl.search(scope.field.date.dateValue.getFullYear(), scope.field.yearField);
                }
                else
                {
                    ctrl.search(undefined, scope.field.dayField);
                    ctrl.search(undefined, scope.field.monthField);
                    ctrl.search(undefined, scope.field.yearField);
                }
            };

            scope.deleteFilter = function()
            {
                scope.field.date.dateValue = null;
                scope.change();
            };

            scope.change();
        }
    }
});
